import { render, staticRenderFns } from "./OrderTabSummary.vue?vue&type=template&id=78a71193&"
import script from "./OrderTabSummary.vue?vue&type=script&lang=js&"
export * from "./OrderTabSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports